export function productInvoiceName(productAlias: string, lineNumber?: any, itemNumber?: any): string {
  if(!productAlias) return '';
  let productInvoiceName: string = productAlias;
  if(lineNumber > 0) {
    if(itemNumber > 0) {
      productInvoiceName = `${productInvoiceName} (${lineNumber}-${itemNumber})`;
    } else {
      productInvoiceName = `${productInvoiceName} (${lineNumber})`;
    }
  } else {
    if(itemNumber > 0) {
      productInvoiceName = `${productInvoiceName} (${itemNumber})`;
    }
  }
  return productInvoiceName;
}